/**
 * Date-extensions locale Serbian Cyrillic [sr-cyrl]
 */
import DateExtended from "../date-extended";
DateExtended.addLocale('sr-cyrl', {
    monthNames: ['јануар','фебруар','март','април','мај','јун','јул','август','септембар','октобар','новембар','децембар'],
    monthShortNames: ['јан.','феб.','мар.','апр.','мај','јун','јул','авг.','сеп.','окт.','нов.','дец.'],
    dayNames: ['недеља','понедељак','уторак','среда','четвртак','петак','субота'],
    dayShortNames: ['нед.','пон.','уто.','сре.','чет.','пет.','суб.']
});
